module.exports = __webpack_public_path__ + "064cbca6b57ce3d2db8b2ad98385958d.png";